import { Typography, Column, Row } from 'seagull';
import styles from "./AdditionalTerms.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const TermItem = _ref => {
  let {
    icon,
    title,
    description,
    testId
  } = _ref;
  return /*#__PURE__*/_jsxs(Row, {
    gap: 12,
    alignItems: "start",
    testId: testId,
    children: [/*#__PURE__*/_jsx(Column, {
      className: styles.iconWrapper,
      children: icon
    }), /*#__PURE__*/_jsxs(Column, {
      children: [/*#__PURE__*/_jsx(Typography, {
        weight: "normal",
        children: title
      }), /*#__PURE__*/_jsx(Typography, {
        variant: "paragraph2",
        skin: "secondary",
        children: description
      })]
    })]
  });
};